import { get } from 'lodash';

const rawCellExtractor = (row, column) =>
  (row[column.key] || {}).hasOwnProperty('value')
    ? {
        [column.key]: (row[column.key] || []).value,
      }
    : {};

const customKeyExtractor = (row, column, key) => ({
  [column.key]: (row[column.key] || [])[key],
});

const extraOptionExtractor = (row, column) => {
  let extractedValue = { [column.key]: +get(row, [column.key, 'value']) };
  let selectedOption =
    (column.options || [])[get(row, [column.key, 'value'])] || undefined;
  let selectedOptionKey = get(selectedOption, 'key');

  if (!selectedOption) {
    extractedValue = { [column.key]: null };
  } else {
    extractedValue = {
      ...extractedValue,
      ...(!!selectedOptionKey
        ? {
            [selectedOptionKey]: Object.assign(
              [],
              get(row, [column.key, selectedOptionKey]) ||
                get(selectedOption, selectedOptionKey)
            ),
          }
        : {}),
    };
  }

  return extractedValue;
};

const formStateExtractors = {
  0: rawCellExtractor,
  1: rawCellExtractor,
  2: rawCellExtractor,
  3: rawCellExtractor,
  5: extraOptionExtractor,
  6: (row, column) => customKeyExtractor(row, column, 'files'),
  7: (row, column) =>
    (row[column.key] || {}).hasOwnProperty('value')
      ? {
          [column.key]: (row[column.key] || {}).value || false,
        }
      : {},
};

export const cellStateReducer = (row, column) => {
  const columnType = get(column, 'columnContentType.columnType');
  const dataExtractor = get(formStateExtractors, columnType, () => ({}));

  return dataExtractor(row, column);
};

export const initialiseValue = (column) => {
  const initialisers = {
    0: null,
    1: null,
    2: null,
    3: null,
    4: [],
    5: null,
    7: null,
  };

  const columnType = get(column, 'columnContentType.columnType');

  return initialisers[columnType];
};
